<!--
 * @Author: your name
 * @Date: 2019-10-24 20:32:55
 * @Description: In User Settings Edit
 -->
<template>
  <div>
    <el-dialog
      lock-scroll
      :modal-append-to-body="false"
      :append-to-body="true"
      :title="$lang('编辑订单')"
      custom-class="j-dialog"
      :close-on-click-modal="false"
      top="45px"
      :visible.sync="visible"
      @close="close"
      width="960px"
    >
      <div class="overflow">
        <el-form class="el-form-edit" ref="orderForm" :rules="rules" :inline="true" :model="formData" label-position="left" label-suffix=" :">
          <!-- <div class="group-title" style="padding:0 0 16px 0;" v-show="comeFrom==='order'">
            <span class="title">寄件人信息</span>
          </div> -->
          <h3 v-show="comeFrom === 'order'">寄件人信息</h3>
          <div class="group-content" v-show="comeFrom === 'order'">
            <el-form-item :label="$lang('姓名')" prop="senderName">
              <el-input v-model="formData.senderName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('联系电话')" prop="senderMobilePhone">
              <el-input v-model="formData.senderMobilePhone" :placeholder="$lang('请输入')" :maxlength="13"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('省/市/区')" prop="senderProvince">
              <BaseAddress ref="senderProvinceSearch" :showLevel="3" :initAddressData="sendAddressData" v-model="formData.senderProvince" @changeValue="senderchangeValue"> </BaseAddress>
            </el-form-item>
            <el-form-item class="el-form-item el-form-item--small" :label="$lang('邮编')" prop="senderPostalCode">
                <el-input v-model="formData.senderPostalCode" :placeholder="$lang('请输入邮编')" :maxlength="5" @input="changeAddress($event, 1)"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('公司名称')" prop="senderCompany">
              <template slot="label"
                ><span :title="$lang('公司名称')">{{ $lang('公司名称') }}</span></template
              >
              <el-input v-model="formData.senderCompany" :placeholder="$lang('请输入公司名称')" :minlength="1" :maxlength="30" />
            </el-form-item>
            <el-form-item class="el-form-item item-col-3 el-form-item--small w360" :label="$lang('详细地址')" prop="senderDetailedAddress">
              <el-input v-model="formData.senderDetailedAddress" :placeholder="$lang('请输入')" :minlength="4" :maxlength="150"></el-input>
            </el-form-item>
          </div>
          <!-- <div class="group-title">
            <span class="title">收件人信息</span>
          </div> -->
          <h3>{{ $lang('收件人信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('姓名')" prop="receiverName">
              <el-input v-model="formData.receiverName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('联系电话')" prop="receiverMobilePhone">
              <el-input v-model="formData.receiverMobilePhone" :placeholder="$lang('请输入')" :maxlength="13"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('省/市/区')" prop="receiverProvince">
              <BaseAddress ref="receiverProvinceSearch" :showLevel="3" :initAddressData="receiverAddressData" v-model="formData.receiverProvince" @changeValue="receiverchangeValue">
              </BaseAddress>
            </el-form-item>
            <el-form-item class="el-form-item el-form-item--small" :label="$lang('邮编')" prop="receiverPostalCode">
                <el-input v-model="formData.receiverPostalCode" :placeholder="$lang('请输入邮编')" :maxlength="5" @input="changeAddress($event, 2)"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('公司名称')" prop="receiverCompany">
              <template slot="label"
                ><span :title="$lang('公司名称')">{{ $lang('公司名称') }}</span></template
              >
              <el-input v-model="formData.receiverCompany" :placeholder="$lang('请输入公司名称')" :minlength="1" :maxlength="30" />
            </el-form-item>
            <el-form-item class="el-form-item item-col-3 el-form-item--small w360" :label="$lang('详细地址')" prop="receiverDetailedAddress">
              <el-input v-model="formData.receiverDetailedAddress" :placeholder="$lang('请输入')" :minlength="4" :maxlength="150"></el-input>
            </el-form-item>
          </div>

          <h3>{{ $lang('货物信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('物品类型')" prop="goods">
              <Base-Select
                v-model="formData.goods"
                :props="{ label: 'name', value: 'code', res: 'appArticleTypeVOList', valueObj: true }"
                dicUrl="/vip/baseData/list"
                :placeholder="$lang('请选择')"
                @change="getupStairsValue"
              ></Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('物品名称')" prop="goodsName">
              <el-input v-model="formData.goodsName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="20"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('物品重量')" prop="packageTotalWeight">
              <el-input-number v-model="formData.packageTotalWeight"  @change="getupStairsValue" label="描述文字" :precision="2" :min="0" :max="99999.9"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('支付方式')" prop="payment">
              <Base-Select
                v-model="formData.payment"
                :props="{ label: 'name', value: 'code', res: 'appPaymentMannerVOList', valueObj: true }"
                dicUrl="/vip/baseData/list"
                :placeholder="$lang('请选择')"
                :disabled="settlementId==319"
              >
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('快递类型')" prop="expressType">
              <Base-Select
                v-model="formData.expressType"
                :props="{ label: 'name', value: 'code', res: 'appProductTypeVOList', valueObj: true }"
                dicUrl="/vip/baseData/list"
                @change="getupStairsValue"
                :placeholder="$lang('请选择')"
              >
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('参考运费')" prop="standardValue" v-if="user.freightStatus === 1">
              <el-input v-model="formData.standardValue" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$lang('客户订单号')" prop="customerOrderId">
              <el-input v-model="formData.customerOrderId" :placeholder="$lang('请输入')" :minlength="1" :maxlength="50"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('是否保价')" prop="insured" class="insured-info">
              <Base-Select
                v-model="formData.insured"
                :clearable="false"
                :dic="DIC.insured"
                :disabled="formData.goodsTypeName === '文件' || formData.paymentModeName === '到付现结' || this.insuranceFlag === 1"
                :placeholder="$lang('请选择')"
                @change="changeInsured"
                :props="{ label: 'name', value: 'code' }"
              ></Base-Select>
              <!-- <a class="btn-insured" @click="openInsured">{{ $lang('保价声明') }}</a> -->
            </el-form-item>
            <el-form-item :label="$lang('保价金额')" prop="declaredValue" v-show="formData.insured === 1" class="declaredValue">
              <el-input-number
                v-model="formData.declaredValue"
                :placeholder="$lang('请输入')"
                :step="1"
                :precision="2"
                :controls="false"
                :min="0"
                :max="200000000"
              ></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('保价费')" prop="insuredValue" v-show="formData.insured === 1">
              <el-input v-model="formData.insuredValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('总件数')" prop="packageNumber">
              <el-input-number v-model="formData.packageNumber" :step="1" :precision="0" :min="1" :max="999"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('长*宽*高*件数(单位cm,多个可用逗号隔开)')" class="w180">
              <el-input v-model="countParams" :placeholder="$lang('多个示例:100*100*100*1,100*100*200*1')">
                <el-button type="primary" slot="append" @click="countWeight">{{ $lang('计算') }}</el-button>
              </el-input>
            </el-form-item>
            <el-form-item :label="$lang('总体积(m³)')" prop="totalPackageVolume">
              <el-input-number v-model="formData.totalPackageVolume" :min="0.001" :precision="3" :max="99.999" @change="countWeightTotal"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('总体积重(kg)')">
              <el-input v-model="formData.packateVolume" disabled :min="0.0" :precision="2" :max="99999.9"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('计费重量(kg)')">
              <el-input v-model="formData.packageChargeWeight" disabled :precision="2" :min="1.0" :max="99999.9"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('退转件指定地点')" prop="receiptFreight">
              <template slot="label">
                <span :title="$lang('退转件指定地点')">{{ $lang('退转件指定地点') }}</span></template
              >
              <Base-Select
                  :clearable="false"
                  v-model="formData.ifTransfer"
                  :dic="transferDic"
                  :placeholder="$lang('请选择')"
                  @change="changeTransfer"
                  :props="{ label: 'name', value: 'code' }"
              >
              </Base-Select>
            </el-form-item>
            <br />
            <h3 v-show="formData.ifTransfer === 1">{{ $lang('退转件人信息') }}</h3>
            <div class="group-content" v-show="formData.ifTransfer === 1">
              <el-form-item :label="$lang('姓名')" prop="transferName">
                <el-input v-model="formData.transferName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="30"></el-input>
              </el-form-item>
              <el-form-item :label="$lang('联系电话')" prop="transferMobilePhone">
                <el-input v-model="formData.transferMobilePhone" :placeholder="$lang('请输入')" :maxlength="13"></el-input>
              </el-form-item>
              <el-form-item :label="$lang('省/市/区')" prop="transferProvince">
                <BaseAddress ref="transferProvinceSearch" :showLevel="3" :initAddressData="transferAddressData" v-model="formData.transferProvince" @changeValue="changeValue">
                </BaseAddress>
              </el-form-item>
              <el-form-item class="el-form-item el-form-item--small" :label="$lang('邮编')" prop="transferPostalCode">
                <el-input v-model="formData.transferPostalCode" :placeholder="$lang('请输入邮编')" :maxlength="5" @input="changeAddress($event, 3)"></el-input>
              </el-form-item>
              <el-form-item :label="$lang('公司名称')" prop="transferCompany">
                <template slot="label"
                ><span :title="$lang('公司名称')">{{ $lang('公司名称') }}</span></template
                >
                <el-input v-model="formData.transferCompany" :placeholder="$lang('请输入公司名称')" :minlength="1" :maxlength="30" />
              </el-form-item>
              <el-form-item class="el-form-item item-col-3 el-form-item--small w360" :label="$lang('详细地址')" prop="transferDetailedAddress">
                <el-input v-model="formData.transferDetailedAddress" :placeholder="$lang('请输入')" :minlength="4" :maxlength="150"></el-input>
              </el-form-item>
            </div>
            <el-form-item :label="$lang('是否上楼')">
              <Base-Select :clearable="false" v-model="formData.isUpstairs" :dic="DIC.insured" :placeholder="$lang('请选择')" :props="{ label: 'name', value: 'code' }">
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('是否电梯')" prop="isElevator" v-if="formData.isUpstairs === 1">
              <Base-Select
                :clearable="false"
                v-model="formData.isElevator"
                :dic="DIC.insured"
                :placeholder="$lang('请选择')"
                @change="getupStairsValue" 
                :props="{ label: 'name', value: 'code' }"
              >
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('上楼费')" v-if="formData.isUpstairs === 1">
              <el-input v-model="formData.upStairsValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item :label="$lang('是否代收货款')" v-show="showCollectionfee">
              <template slot="label">
                <span :title="$lang('是否代收货款')">{{ $lang('是否代收货款') }}</span></template
              >
              <Base-Select
                :clearable="false"
                v-model="formData.isCollectionfee"
                :dic="collectionfeeDic"
                :placeholder="$lang('请选择')"
                @change="changeCollectionfee"
                :props="{ label: 'name', value: 'code' }"
              >
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('代收货款金额')" class="declaredValue" v-show="showCollectionfee">
              <template slot="label"> 
                <span :title="$lang('代收货款金额')">{{ $lang('代收货款金额') }}</span></template
              >
              <el-input-number
                v-model="formData.collectionfee"
                :disabled="collectionfeeDis"
                :placeholder="$lang('请输入')"
                :step="1"
                :precision="2"
                :controls="false"
                :min="0"
                :max="200000000"
                @blur="blurCollectionfee"
              ></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('代收货款手续费')" class="declaredValue" v-show="showCollectionfee">
              <template slot="label">
                <span :title="$lang('代收货款手续费')">{{ $lang('代收货款手续费') }}</span></template
              >
              <el-input-number
              :disabled="true"
                v-model="formData.collectionfeeTax"
                :placeholder="$lang('请输入')"
                :step="1"
                :precision="2"
                :controls="false"
                :min="0"
                :max="200000000"
              ></el-input-number>
            </el-form-item>
               <!-- 是否签回单  :disabled="formData.paymentModeName === 'PP_PM' "-->
            <el-form-item :label="$lang('是否签回单')" prop="signReceipt">
              <template slot="label">
                <span :title="$lang('是否签回单')">{{ $lang('是否签回单') }}</span></template
              >
              <Base-Select
                :clearable="false"
                v-model="formData.signReceipt"
                :dic="signReceiptDic"
                :placeholder="$lang('请选择')"
                :disabled="isReceiptFlag === 0"
                @change="changeSignReceipt"
                :props="{ label: 'name', value: 'code' }"
              >
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('回单类型')" prop="receiptFreight" v-show="formData.signReceipt === 1">
              <el-input v-model="formData.receiptBusinessName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('备注')" prop="remarks" style="width:860px;">
              <el-input type="textarea" v-model="formData.remarks" :maxlength="50" :label="$lang('描述文字')"></el-input>
            </el-form-item>

          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <!-- <el-button @click="close">{{ $lang('取消') }}</el-button> -->
        <el-button type="primary" :loading="keyBtn" @click="sumbit" class="h40">{{ $lang('保 存') }}</el-button>
      </div>
      <InsuredStatement :infoVisible="infoVisible" @closeInsured="closeInsured"></InsuredStatement>
    </el-dialog>
  </div>
</template>

<script>
import { DIC, RESPONSE_SUCCESS } from '@constants'
import { mapGetters } from 'vuex'
import { RULES, phoneAndMobile, checkAddressFormat, integerWeight, isNullObj, isName, VALIDATION } from '@utils/rules'
import { customerInfo,getComCost, getSettlement, getComputationCost, getList, checkRepeatCustomerOrderId, getCoefficientByQuery, getInsuranceFlag,getupStairsValue, queryCustomerCodConfig,queryCodCalc } from '@api/module/customer'
import InsuredStatement from '@components/dialog/InsuredStatement'
import debounce from 'lodash/debounce'
import * as Api from '@api/base/public'
import dayjs from 'dayjs'
export default {
  name: 'EditOrder',
  components: {
    InsuredStatement,
  },
  props: {
    value: {},
    orderData: {
      type: Object,
      default: function() {
        return {}
      },
    },
    comeFrom: {
      type: String,
      default: function() {
        return 'order'
      },
    },
    disablePayment: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      DIC,
      keyBtn: false,
      data: '',
      visible: false,
      infoVisible: false, // 保价费声明弹窗
      showCollectionfee:false,
      maxCollectionMoney:0,//代收款上限
      businessModelType:-1,//代收款类型  32直营  33加盟
      collectionfeeDis:true,//代收款禁用
      isReceiptFlag: 0,
      settlementId:0,
      formData: {
        signReceipt: 0, // 签回单 0否 1是
        receiptBusinessName: '',
        isCollectionfee:0,//是否代收货款  
        collectionfee:0.00,//代收货款金额
        collectionfeeTax:0.00,//代收货款手续费
        senderName: '', // 寄件人姓名,
        senderMobilePhone: '', // 寄件人手机号,
        senderProvince: {},
        senderProvinceId: '', // 寄件省份id,
        senderProvinceName: '', // 寄件省份名称,
        senderCityId: '', // 寄件城市id,
        senderCityName: '', // 寄件城市名称,
        senderAreaId: '', // 寄件区域id,
        senderAreaName: '', // 寄件区域名称,
        // senderTownshipId: '', // 寄件乡镇id,
        // senderTownship: '', // 寄件乡镇名称,
        senderLocal: '', // 寄件区省/市/区
        senderDetailedAddress: '', // 寄件详细地址,
        senderPostalCode: '', // 寄件邮编,
        receiverName: '', // 收件人姓名,
        receiverMobilePhone: '', // 收件人手机号,
        receiverProvince: {},
        receiverProvinceId: '', // 收件省份id,
        receiverProvinceName: '', // 收件省份名称,
        receiverCityId: '', // 收件城市id,
        receiverCityName: '', // 收件城市名称,
        receiverAreaId: '', // 收件区域id,
        receiverAreaName: '', // 收件区域名称,
        // receiverTownshipId: '', // 收件乡镇id,
        // receiverTownship: '', // 收件乡镇名称,
        receiverLocal: '', // 收件区省/市/区
        receiverDetailedAddress: '', // 收件详细地址,
        receiverPostalCode: '', // 收件邮编,
        insured: 0, // 是否保价1是，0否,
        declaredValue: '', // 保价金额,
        insuredValue: '', // 保价费,
        goods: '', // 物品类型
        goodsTypeId: '', // 物品类型id,
        goodsTypeCode: '', // 物品类型编码,
        goodsTypeName: '', // 物品类型名称,
        goodsName: '', // 物品名称,
        packageTotalWeight: 0, // 物品重量,
        packageNumber: 1, // 物品件数,
        payment: '', // 支付方式
        paymentModeId: '', // 支付方式id,
        paymentModeCode: '', // 支付方式编码,
        paymentModeName: '', // 支付方式名称,
        expressType: '', // 快递类型
        expressTypeCode: '', // 快递类型code
        expressTypeName: '', // 快递类型name
        codMoney: '', // COD,
        codFee: 0, // COD手续费,
        standardValue: 0, // 参考运费,
        boxStandard: '', // 箱材规格
        boxStandardId: '', // 箱材规格id,
        boxStandardCode: '', // 箱材规格编码,
        boxStandardName: '', // 箱材规格名称,
        boxPrice: 0, // 箱材单价,
        remarks: '', // 备注,
        settlementWeight: 0, // 结算重量
        packageChargeWeight: 1, // 结算重量,
        customerOrderId: '',
        totalPackageVolume: 0, // 总体积
        standardCost: 0, // 标准金额
        ifTransfer: 0, // 是否退转件
        transferName: '', // 退转件姓名,
        transferMobilePhone: '', // 退转件手机号,
        transferProvinceId: '', // 退转件省份id,
        transferProvinceName: '', // 退转件省份名称,
        transferCityId: '', // 退转件城市id,
        transferCityName: '', // 退转件城市名称,
        transferAreaId: '', // 退转件区域id,
        transferAreaName: '', // 退转件区域名称,
        // transferTownshipId: '', // 退转件乡镇id,
        // transferTownshipName: '', // 退转件乡镇名称,
        transferProvince: {}, // 退转件区省/市/区
        transferDetailedAddress: '', // 退转件详细地址,
        transferCompany: '', // 退转件公司名称
        transferPostalCode: '', // 退转件邮编
        isUpstairs: 0, // 是否上楼
        upStairsValue: 0, // 上楼费
        isElevator: 0, // 是否电梯,是1 否2
      },
      rules: {},
      sendAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
          townIdProp: 'townId',
          townNameProp: 'townName',
          zipcodeProp: 'zipcode',
        },
        defaultData: {},
      },
      receiverAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
          townIdProp: 'townId',
          townNameProp: 'townName',
          zipcodeProp: 'zipcode',
        },
        defaultData: {},
      },
      transferDic: [
        { code: 0, label: this.$lang('否'), name: this.$lang('否') },
        { code: 1, label: this.$lang('是'), name: this.$lang('是') },
      ],
      collectionfeeDic: [
        { code: 0, label: this.$lang('否'), name: this.$lang('否') },
        { code: 1, label: this.$lang('是'), name: this.$lang('是') },
      ],
      signReceiptDic: [
        { code: 0, label: this.$lang('否'), name: this.$lang('否') },
        { code: 1, label: this.$lang('是'), name: this.$lang('是') },
      ],
      transferAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
          townIdProp: 'townId',
          townNameProp: 'townName',
          zipcodeProp: 'zipcode',
        },
        defaultData: {},
      },
      startAddressId: null,
      endAddressId: null,
      countParams: '',
      appProductTypeVOList: [], // 轻抛系数列表
      prevStandardCost: -1, // 记录上一次标准金额值
      insuranceFlag: 0,
    }
  },
  watch: {
    comeFrom: {
      handler(val) {
        if (val === 'order') {
          this.rules = {
            senderName: [RULES.requiredTrim, { validator: isName }],
            senderMobilePhone: [RULES.required, { validator: phoneAndMobile }, RULES.lengthTenThirdteen],
            senderProvince: [RULES.requiredSelect],
            senderDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
            receiverName: [RULES.required, { validator: isName }],
            receiverMobilePhone: [RULES.required, { validator: phoneAndMobile }, RULES.lengthTenThirdteen],
            receiverProvince: [RULES.requiredSelect, { validator: isNullObj }],
            receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
            goods: [RULES.requiredSelect],
            // goodsName: [RULES.required, { validator: checkGoodsName }],
            packageTotalWeight: [RULES.required, { validator: integerWeight }],
            payment: [RULES.requiredSelect],
            insured: [RULES.requiredSelect],
            packageNumber: [RULES.required],
            totalPackageVolume: [RULES.required],
            expressType: [RULES.requiredSelect],
          }
        } else {
          this.rules = {
            receiverName: [RULES.requiredTrim, { validator: isName }],
            receiverMobilePhone: [RULES.requiredTrim, { validator: phoneAndMobile }, RULES.lengthTenThirdteen],
            receiverProvince: [RULES.requiredSelect, { validator: isNullObj }],
            receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
            goods: [RULES.requiredSelect],
            packageTotalWeight: [RULES.required, { validator: integerWeight }],
            payment: [RULES.requiredSelect],
            insured: [RULES.requiredSelect],
            packageNumber: [RULES.required],
            totalPackageVolume: [RULES.required],
            expressType: [RULES.requiredSelect],
          }
        }
      },
      immediate: true,
    },
    value: {
      handler(val) {
        this.visible = val
        // 每次打开编辑框时清空长*宽*高输入框
        if (val) {
          this.countParams = ''
        }
      },
      immediate: true,
    },
    orderData: {
      handler(val) {
       
        debugger
        // 箱材规格 初始化
        const boxStandard = {
          id: val.boxStandardId,
          materialCode: val.boxStandardCode,
          materialName: val.boxStandardName,
          boxPrice: val.boxPrice,
          salesPrice: val.boxPrice,
          name: val.boxStandardName,
          code: val.boxStandardCode,
        }
        const goods = {
          id: val.goodsTypeId,
          code: val.goodsTypeCode,
          name: val.goodsTypeName,
        }
        const payment = {
          id: val.paymentModeId,
          code: val.paymentModeCode,
          name: val.paymentModeName,
        }
        const expressType = {
          code: val.expressTypeCode, // 快递类型code
          name: val.expressTypeName, // 快递类型name
        }
        let isReceiptFlag=val.signReceipt
        // this.formData = Object.assign(...val, { boxStandard }, { goods }, { payment }, { expressType })
        this.formData = { ...val, ...{ boxStandard, goods, payment, expressType,isCollectionfee:0,
        collectionfee:0.00,
        collectionfeeTax:0.00,isReceiptFlag }}
        this.handleProvice(this.formData)
        // 初始化 箱材规格
        this.getInsuranceFlag()
        this.verifyCollectionfee()

        if(this.formData.codMoney){
          this.formData.isCollectionfee=1
          this.formData.collectionfee=this.formData.codMoney
          setTimeout(()=>{
            this.blurCollectionfee1()
          },1000)
         
        }
        this.getCustomerInfo() 
        
      
        
        
      },
      deep: true,
    },
    async 'formData.collectionfeeTax'(val){
      debugger
      if(val){
       console.log("vlavlavlal",val)
      }
    },
    
    async 'formData.receiverAreaId'(val){
      if(val){
        this.verifyCollectionfee()
      }else{
        debugger
        this.showCollectionfee=false
        this.formData.isCollectionfee=0
        this.formData.collectionfee=0.00
        this.formData.collectionfeeTax=0.00

      }
    },
  
    async 'formData.receiverDetailedAddress'(val){
      if(val){
        this.verifyCollectionfee()
      }else{
        debugger
        this.showCollectionfee=false
        this.formData.isCollectionfee=0
        this.formData.collectionfee=0.00
        this.formData.collectionfeeTax=0.00
      }
    },

    // 物品类型
    async 'formData.goods'(val) {
      const { id: goodsTypeId, code: goodsTypeCode, name: goodsTypeName } = val || {}
      Object.assign(this.formData, { goodsTypeId, goodsTypeCode, goodsTypeName })
      const { declaredValue, goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(declaredValue) > 0) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
        this.prevStandardCost = -1
      }
      if (goodsTypeName === '文件') {
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
        this.formData.insuredValue = 0
        this.prevStandardCost = -1
      }
    },
    // 支付方式
    async 'formData.payment'(val) {
      const { id: paymentModeId, code: paymentModeCode, name: paymentModeName } = val || {}
      Object.assign(this.formData, { paymentModeId, paymentModeCode, paymentModeName })
      const { senderProvince, receiverProvince, packageTotalWeight } = this.formData
      if (senderProvince && receiverProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      // 到付现结不支持保价
      if (val.name === '到付现结') {
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
        this.formData.insuredValue = 0
        this.prevStandardCost = -1
      }
    },
    async 'formData.expressType'(val) {
      const { code, name } = val
      Object.assign(this.formData, { expressTypeCode: code, expressTypeName: name })
      // 重新计算轻抛系数
      this.countWeightTotal()
    },
    // 物品重量
    async 'formData.packageTotalWeight'(val) {
      const { packateVolume } = this.formData
      this.formData.packageChargeWeight = packateVolume > val ? packateVolume : val
    },
    // 计费重量
    async 'formData.packageChargeWeight'(val) {
      const { senderProvince, receiverProvince } = this.formData
      if (senderProvince && receiverProvince && val > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 保价费计算
    async 'formData.declaredValue'(val) {
      const { goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(val) > 0) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
        this.prevStandardCost = -1
      }
    },
    // 转换计算长度变化
    async 'formData.packageLength'(val, oldval) {
      if (Number(val) !== Number(oldval)) {
        this.mergeWidthHeightLength()
      }
    },
    // 转换计算宽度变化
    async 'formData.packageWide'(val, oldval) {
      if (Number(val) !== Number(oldval)) {
        this.mergeWidthHeightLength()
      }
    },
    // 转换计算高度变化
    async 'formData.packageHigh'(val, oldval) {
      if (Number(val) !== Number(oldval)) {
        this.mergeWidthHeightLength()
      }
    },
    async 'formData.isUpstairs'(val) {
      if (Number(val) === 0) {
        this.formData.upStairsValue = 0
        this.formData.isElevator = 0
      }
    },
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
  created() {
    if (this.formData.insured === 1) {
      // 是否保价1是，0否,
      this.rules.declaredValue = [RULES.required, RULES.declaredValue]
    }
  },
  mounted() {
    this.calcStandardCost(this.formData)
    this.getLightTossCoefficient()
    // this.mergeWidthHeightLength()
  },


  methods: {
    // 客户资料查询
    async getCustomerInfo() {
      const { data } = await customerInfo()
      console.log('getCustomerInfo...............', data)

      this.isReceiptFlag = data.isReceiptFlag
      if(!this.isReceiptFlag){
        this.formData.signReceipt=0
      }else{
        this.receiptBusinessName = data.receiptBusinessName
         this.formData.receiptBusinessName = data.receiptBusinessName

      }
      this.settlementId=data.settlementId
      debugger
      if(this.settlementId&&this.settlementId==319){
        this.formData.paymentModeCode='PP_PM'
        this.formData.paymentModeId='7'
        this.formData.paymentModeName='PP_PM'
        this.formData.payment={code: "PP_PM", name: "Bulanan", id: 7, type: "ZD106"}
      }
      
      //如客户未开启回单或未维护【回单费】则前端默认写死，现改为客户未开启回单或未维护【回单费】则调财务接口获取
    
      
     
      // if (!this.receiptFreight) {
      //   this.calFeeReceipt()
      // }
    },
    
     /**
     * 是否签回单
     */
     changeSignReceipt(val) {
      if (val === 0) {
        this.formData.receiptFreight = 0
        this.formData.receiptBusinessName = ''
        this.formData.receiptBusinessType = ''
        this.formData.signReceipt = 0

      } else if (val === 1) {
        if(this.receiptBusinessName){
          this.formData.signReceipt = 1

          this.formData.receiptBusinessName = this.receiptBusinessName
        
        }
      }
    },
    async blurCollectionfee(val){
      debugger
      if(!this.formData.collectionfee||this.formData.collectionfee==0){
        this.$message.error(this.$lang("代收款金额不能为0"))
      }else if(this.businessModelId==33&&(parseFloat(this.formData.collectionfee)>parseFloat(this.maxCollectionMoney))){
         this.$message.error(this.$lang("该目的网点代收上限")+this.maxCollectionMoney)
          this.formData.collectionfee=0.00
          this.formData.collectionfeeTax=0.00
        
        
      }else{
        const now = new Date()
       const res =await queryCodCalc({
        collectionfee:this.formData.collectionfee,
        dateTime:dayjs(now).format('YYYY-MM-DD HH:mm:ss'),
        customerCode:this.user.customerCode
      })
      if(res&&res.data){
        if(res.data.customerFee){
          this.formData.collectionfeeTax=res.data.customerFee
          debugger
        }
      }
      }
      
     
    },
    async blurCollectionfee1(val){
      debugger
       if(this.businessModelId==33&&(parseFloat(this.formData.collectionfee)>parseFloat(this.maxCollectionMoney))){
         this.$message.error(this.$lang("该目的网点代收上限")+this.maxCollectionMoney)
          this.formData.collectionfee=0.00
          this.formData.collectionfeeTax=0.00
        
        
      }else{
        const now = new Date()
       const res =await queryCodCalc({
        collectionfee:this.formData.collectionfee,
        dateTime:dayjs(now).format('YYYY-MM-DD HH:mm:ss'),
        customerCode:this.user.customerCode
      })
      if(res&&res.data){
        if(res.data.customerFee){
          this.formData.collectionfeeTax=res.data.customerFee
        }
      }
      }
      
     
    },
    async verifyCollectionfee(obj={}){
      console.log(this.formData.receiverDetailedAddress)
      if((this.formData.receiverAreaId||obj.areaId)&&this.formData.receiverDetailedAddress){
        const res = await queryCustomerCodConfig({
          provinceId:obj.provinceId?obj.provinceId:this.formData.receiverProvinceId,
          cityId:obj.cityId?obj.cityId:this.formData.receiverCityId,
          areaId:obj.areaId?obj.areaId:this.formData.receiverAreaId,
          province:obj.provinceName?obj.provinceName:this.formData.receiverProvinceName,
          city:obj.cityName?obj.cityName:this.formData.receiverCityName,
          area:obj.areaName?obj.areaName:this.formData.receiverAreaName,
          details:this.formData.receiverDetailedAddress,
        })
        if(res&&res.code==1&&res.data){
          if(res.data.maxCollectionMoney){
            this.maxCollectionMoney=res.data.maxCollectionMoney
          }
          if(res.data.isOpenCod==1){
            debugger
            this.showCollectionfee=true
          }else if(res.data.isOpenCod==2){
            debugger
            this.showCollectionfee=false
            this.formData.collectionfee=0.00
            this.formData.collectionfeeTax=0.00
            this.formData.isCollectionfee = 0
          }
          if(res.data.businessModelId){
            this.businessModelId=res.data.businessModelId
          }
        }
      }

    
      
    },
// 是否代收货款
changeCollectionfee(val) {
    debugger
      if(val==0){
        this.formData.isCollectionfee=0
        this.formData.collectionfee=0.00
        this.formData.collectionfeeTax=0.00
        this.collectionfeeDis=true
      }else if(val==1){
        this.collectionfeeDis=false
      }

      console.log(this.formData.isCollectionfee)
    },

    async getupStairsValue() {
      // 获取上楼费
      const { packateVolume } = this.formData
      this.formData.packageChargeWeight = packateVolume > this.formData.packageTotalWeight ? packateVolume : this.formData.packageTotalWeight

      if ((!this.formData.isUpstairs || this.formData.isUpstairs !== 0) && !this.formData.isElevator && this.formData.isElevator !== 0) {
        return
      }
      this.$refs['orderForm'].validate(async (valid) => {
        if (valid) {
          this.keyBtn = true
          const params = {
            costNum: this.formData.packageNumber, // 件数
            costWeight: this.formData.packageChargeWeight, // 计费重量
            goodsCode: this.formData.goods.code, // 物品类型code
            isElevator: this.formData.isElevator, // 是否电梯,是1 否2
            productTypeCode: this.formData.expressType.code, // 产品类型code
          }
          const { code, data, msg } = await getupStairsValue(params)
          if (code === RESPONSE_SUCCESS) {
            this.formData.upStairsValue = data || 0
          } else {
            this.$message.error(msg)
          }
          this.keyBtn = false
        }
      })
    },
    // 实时获取是否强制保价
    async getInsuranceFlag() {
      const params = {
        id: this.userInfo.id,
      }
      const { data, msg, code } = await getInsuranceFlag(params)
      if (code === RESPONSE_SUCCESS) {
        if (data === 1) {
          // 是否保价1是，0否,
          this.insuranceFlag = 1
          this.formData.insured = 1
          this.rules.declaredValue = [RULES.required, RULES.declaredValue]
        } else {
          this.insuranceFlag = 0
          this.rules.declaredValue = []
        }
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 合并长宽高
    mergeWidthHeightLength: debounce(async function() {
      // 不再自动设置countParams，保持用户输入的长*宽*高编辑框为空
      // 这样确保"任何情况进入编辑页面都清空长*宽*高编辑框"
    }, 200),
    // 获取轻抛系数
    async getLightTossCoefficient() {
      const { code, data, msg } = await getList()
      if (code === RESPONSE_SUCCESS) {
        if (data.appProductTypeVOList) {
          this.appProductTypeVOList = data.appProductTypeVOList
        }
      } else {
        this.$message.warning(msg)
      }
    },
    // 计算体积
    countWeight() {
      if (!this.countParams) {
        this.$message.warning(this.$lang('输入有误，已被忽略求总体积!'))
        return false
      }
      // 新增：支持多个体积项
      const items = this.countParams.split(',')
      let totalVolume = 0
      let totalNumber = 0
      let firstLength = null, firstWide = null, firstHigh = null
      // 用于导出到列表的长*宽*高字符串（不含件数）
      let packageSpecification = ''
      
      for (let i = 0; i < items.length; i++) {
        const item = items[i].trim()
        if (!item) continue
        const parts = item.split('*')
        console.log(parts,"partspartsparts")
        if (parts.length !== 4) {
          this.$message.warning(this.$lang('输入有误，请重新输入'))
          return false
        }
        const [length, wide, high, number] = parts
        // 校验必须为正整数且最大5位
        if ([length, wide, high, number].some(x => !/^[1-9]\d{0,4}$/.test(x))) {
          this.$message.warning(this.$lang('输入有误，请重新输入'))
          return false
        }
        if (firstLength === null) {
          firstLength = length
          firstWide = wide
          firstHigh = high
        }
        totalVolume += Number(length) * Number(wide) * Number(high) * Number(number)
        totalNumber += Number(number)
        
        // 构建包装规格字符串（长*宽*高，不含件数）
        if (packageSpecification) {
          packageSpecification += ','
        }
        packageSpecification += `${length}*${wide}*${high}`
      }
      if (totalVolume > 99999000) {
        this.$message.warning(this.$lang('总体积超额，请重新填写'))
        return false
      }
      // 赋值：取第一个项的长宽高
      this.formData.packageLength = firstLength
      this.formData.packageWide = firstWide
      this.formData.packageHigh = firstHigh
      // 赋值：总体积和总件数
      this.formData.totalPackageVolume = (totalVolume / 1000000).toFixed(3)
      this.formData.packageNumber = totalNumber
      // 赋值：包装规格（用于列表显示）
      this.formData.packageSpecification = packageSpecification
      this.countWeightTotal()
      this.getupStairsValue()
      return true
    },
    // 轻抛系数计算体积重
    async countWeightTotal() {
      const { expressTypeCode, packageTotalVolume, packageTotalWeight } = this.formData
      const data = await this.getCoefficientByQuery(expressTypeCode)
      if (data && (packageTotalVolume || packageTotalVolume === 0)) {
        // 体积重=根据总体积/轻抛系数
        const packateVolume = ((totalPackageVolume * 1000000) / data.lightThrowingCoefficient).toFixed(2)
        if (packateVolume > 99999.9) {
          this.$message.warning(this.$lang('体积重限额，请重新调整总体积'))
          return
        }
        this.formData.packateVolume = packateVolume
        this.formData.packageChargeWeight = packateVolume > packageTotalWeight ? packateVolume : packageTotalWeight
      }
         // 计算上楼费
         this.getupStairsValue()
      // 计算运费
      this.calcStandardCost(this.formData)
    },
    openInsured() {
      this.infoVisible = true
    },
    closeInsured() {
      this.infoVisible = false
    },
    async changeInsured(val) {
      this.formData.insured = val
      if (val === 0) {
        this.formData.insuredValue = 0
        this.formData.declaredValue = ''
        this.prevStandardCost = -1
      }
      const { goods, declaredValue } = this.formData
      if (val === 1 && goods && declaredValue && parseFloat(declaredValue)) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
        this.prevStandardCost = -1
      }
    },
    changeBoxStandard(val) {
      if (!val) {
        this.formData.boxPrice = 0
      }
      if (val && val.salesPrice) {
        const { id: boxStandardId, name: boxStandardName, salesPrice: boxPrice } = val
        Object.assign(this.formData, {
          // 箱材规格id
          boxStandardId,
          // 箱材规格名称
          boxStandardName,
          // 箱材单价
          boxPrice,
        })
      }
    },
    validateTransfer() {
      
      if (this.formData.ifTransfer === 1) {
        if (this.formData.transferName === null || this.formData.transferName === '') {
          this.$message.warning(this.$lang('退转件人姓名不能为空'))
          return false
        }
        if (this.formData.transferName.length > 50) {
          this.$message.warning(this.$lang('退转件人姓名长度不能大于50个字符'))
          return false
        }
        if (this.formData.transferMobilePhone === null || this.formData.transferMobilePhone === '') {
          this.$message.warning(this.$lang('退转件人联系电话不能为空'))
          return false
        }
        if (!VALIDATION.phoneAndMobile.value.test(this.formData.transferMobilePhone)) {
          this.$message.warning(this.$lang('退转件人联系电话格式不正确'))
          return false
        }
        if (this.formData.transferProvince === null || this.formData.transferProvince === '') {
          this.$message.warning(this.$lang('退转件人省市区不能为空'))
          return false
        }
        if (this.formData.transferDetailedAddress === null || this.formData.transferDetailedAddress === '') {
          this.$message.warning(this.$lang('退转件人详细地址不能为空'))
          return false
        }
      }
    },
    async sumbit() {
      // 新增：先校验体积格式
      if (this.countParams) {
        const valid = this.countWeight()
        if (!valid) return
      }
      var validateTransferResult = this.validateTransfer()
      if (validateTransferResult === false) {
        return
      }
      if (this.formData.isCollectionfee == 1 &&!this.formData.collectionfee) {
        this.$message.error(this.$lang('代收货款金额必须大于0'))
        return
      }
      debugger
      if (this.formData.ifTransfer === 0) {
        this.formData.transferName = ''
        this.formData.transferMobilePhone = ''
        this.formData.transferProvinceId = ''
        this.formData.transferProvinceName = ''
        this.formData.transferCityId = ''
        this.formData.transferCityName = ''
        this.formData.transferAreaId = ''
        this.formData.transferAreaName = ''
        // this.formData.transferTownshipName = ''
        // this.formData.transferTownshipId = ''
        this.formData.transferProvince = ''
        this.formData.transferDetailedAddress = ''
        this.formData.transferCompany = ''
        this.formData.transferPostalCode = ''
      }
      if (this.formData.paymentModeId === 321 && this.formData.insured !== 0) {
        this.$message.error(this.$lang('到付件不支持保价'))
        return
      }
      if (this.formData.insured === 1 && (!this.formData.declaredValue || parseFloat(this.formData.declaredValue) <= 0)) {
        this.$message.error(this.$lang('保价金额必须大于0'))
        return
      }
      if (this.formData.isUpstairs === 1 && !this.formData.upStairsValue && this.formData.upStairsValue !== 0) {
        this.$message.error(this.$lang('暂不支持上楼服务'))
        return
      }
      if (this.formData.customerOrderId) {
        if ((await this.addOrderCheckRepeatCustomerOrderId(this.formData.customerOrderId)) === false) {
          this.$message.error(this.$lang('客户订单号重复'))
          return
        }
      }
      this.formData.codNeed=this.formData.isCollectionfee
      this.formData.codMoney=this.formData.collectionfee
      this.formData.codFee=this.formData.collectionfeeTax

      this.$emit('editSave', this.formData)
    },
    close() {
    debugger
      this.showCollectionfee=false;
      this.maxCollectionMoney=0;//代收款上限
      this.businessModelType=-1;//代收款类型  32直营  33加盟
      this.collectionfeeDis=true;//代收款禁用
      this.formData.isCollectionfee=0;
      this.formData.collectionfee=0.00;
      this.formData.collectionfeeTax=0.00;
      this.formData.receiverDetailedAddress='';
      this.formData.receiverPostalCode='';
      this.formData.receiverName='';
      this.formData.receiverMobilePhone='';
      this.formData.receiverProvince={};
      this.formData.receiverProvinceId='';
      this.formData.receiverProvinceName='';
      this.formData.receiverCityId='';
      this.formData.receiverCityName='';
      this.formData.receiverAreaId='';
      this.formData.receiverAreaName='';

      this.receiverAddressData={
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
          townIdProp: 'townId',
          townNameProp: 'townName',
          zipcodeProp: 'zipcode',
        },
        defaultData: {},
      }
      this.$emit('editClose', false)
      debugger

    },
    async addOrderCheckRepeatCustomerOrderId(customerOrderId) {
      const param = {
        'customerOrderId': customerOrderId,
      }
      const { code, data, msg } = await checkRepeatCustomerOrderId(param)
      if (code === RESPONSE_SUCCESS) {
        return data
      } else {
        this.$message.warning(msg)
      }
    },
    async getCoefficientByQuery(expressTypeCode) {
      if (!expressTypeCode) {
        return null
      }
      const { code, data, msg } = await getCoefficientByQuery({ 'code': expressTypeCode })
      if (code === RESPONSE_SUCCESS) {
        return data
      } else {
        this.$message.error(msg)
        return null
      }
    },
    // 运费计算
    calcStandardCost: debounce(async function(data) {
      const { senderProvince, receiverProvince, packageChargeWeight, paymentModeId } = data
      const result = {
        // 寄件省份id
        senderProvinceId: senderProvince.provinceId,
        // 寄件省份名称
        senderProvinceName: senderProvince.provinceName,
        // 寄件城市id
        senderCityId: senderProvince.cityId,
        // 寄件城市名称
        senderCityName: senderProvince.cityName,
        // 寄件区域id
        senderAreaId: senderProvince.areaId,
        // 寄件区域名称
        senderAreaName: senderProvince.areaName,
        // 收件省份id
        receiverProvinceId: receiverProvince.provinceId,
        // 收件省份名称
        receiverProvinceName: receiverProvince.provinceName,
        // 收件城市id
        receiverCityId: receiverProvince.cityId,
        // 收件城市名称
        receiverCityName: receiverProvince.cityName,
        // 收件区域id
        receiverAreaId: receiverProvince.areaId,
        // 收件区域名称
        receiverAreaName: receiverProvince.areaName,
      }
      // 运费
      const obj = {}
      if (result.senderAreaId && result.receiverAreaId) {
        const promises = [
          // 获取起始地址ID
          this.getSettlement(result.senderProvinceId, result.senderCityId, result.senderAreaId),
          // 获取目的地地址ID
          this.getSettlement(result.receiverProvinceId, result.receiverCityId, result.receiverAreaId),
        ]
        const [startAddressId, endAddressId] = await Promise.all(promises)
        // 如果起始地址且目的地地址ID存在
        if (startAddressId && endAddressId) {
          // 获取运费
          const res = await this.getComCost(packageChargeWeight, startAddressId, endAddressId, paymentModeId)
          obj.standardValue = res.cost
          obj.settlementWeight = res.setWeight
          this.formData.standardValue = res.cost
          this.formData.standardCost = res.standardCost // 标准金额字段 用来计算保价费的
          this.calcInsuredCost() // 执行保价费计算
        } else {
          // 保价时，若起始地址id存在null，设置参考运费、标准金额以及保价费为0,初始化上一次标准金额值
          if (this.formData.insured == 1) {
            this.formData.standardValue = 0
            this.formData.standardCost = 0
            this.formData.insuredValue = 0
            this.prevStandardCost = -1
          }
        }
      }
      // 返回结果
      return {
        ...result,
        ...obj,
      }
    }, 200),
    // 城市重新赋值
    handleProvice(row) {
      const {
        senderProvinceId,
        senderProvinceName,
        senderCityId,
        senderCityName,
        senderAreaId,
        senderAreaName,
        // senderTownship,
        // senderTownshipId,
        receiverProvinceId,
        receiverProvinceName,
        receiverCityId,
        receiverCityName,
        receiverAreaId,
        receiverAreaName,
        // receiverTownshipId,
        // receiverTownship,
        transferProvinceId,
        transferProvinceName,
        transferCityId,
        transferCityName,
        transferAreaId,
        transferAreaName,
        // transferTownshipId,
        // transferTownshipName,
      } = row
      const sendObj = {}
      sendObj.provinceId = senderProvinceId
      sendObj.provinceName = senderProvinceName
      sendObj.cityId = senderCityId
      sendObj.cityName = senderCityName
      sendObj.areaId = senderAreaId
      sendObj.areaName = senderAreaName
      // sendObj.townId = senderTownshipId
      // sendObj.townName = senderTownship
      Object.assign(this.sendAddressData, { defaultData: sendObj })
      const receiverObj = {}
      receiverObj.provinceId = receiverProvinceId
      receiverObj.provinceName = receiverProvinceName
      receiverObj.cityId = receiverCityId
      receiverObj.cityName = receiverCityName
      receiverObj.areaId = receiverAreaId
      receiverObj.areaName = receiverAreaName
      // receiverObj.townId = receiverTownshipId
      // receiverObj.townName = receiverTownship
      Object.assign(this.receiverAddressData, { defaultData: receiverObj })
      const transferObj = {}
      transferObj.provinceId = transferProvinceId
      transferObj.provinceName = transferProvinceName
      transferObj.cityId = transferCityId
      transferObj.cityName = transferCityName
      transferObj.areaId = transferAreaId
      transferObj.areaName = transferAreaName
      // transferObj.townId = transferTownshipId
      // transferObj.townName = transferTownshipName
      Object.assign(this.transferAddressData, { defaultData: transferObj })
    },
    // 通过省市区匹配结算目的地(目的区域)
    async getSettlement(providerId, cityId, areaId, packageTotalWeight, type) {
      const reqData = { providerId, cityId, areaId }
      const { code, data } = await getSettlement(reqData)
      if (code === 1 && data) {
        const id = data.id
        return id
      } else {
        return ''
      }
    },
    // 运费计算
    async getComCost(number, startAddressId, endAddressId, paymentModeId) {
      let smMode = 2
      if (paymentModeId) {
        switch (paymentModeId) {
          case 320:
            smMode = 1
            break
          case 319:
            smMode = 2
            break
          case 321:
            smMode = 3
            break
        }
      }
      const reqData = { startAddressId, endAddressId, number, smMode }
      const { data = 0 } = await getComCost(reqData)
      return data || 0
    },
    // 保价费计算
    async getComputationCost(param) {
      // 参数
      const params = {
        // 保价金额
        value: param.declaredValue,
        // 物品类型code
        goodsTypeCode: param.goods.code,
        standardCost: param.standardCost,
      }
      // 调用接口
      const { data } = await getComputationCost(params)
      return data || 0
    },
    // 保价费计算方法
    async calcInsuredCost() {
      if (this.prevStandardCost != -1 && this.prevStandardCost == this.formData.standardCost) {
        return false
      }
      this.prevStandardCost = this.formData.standardCost

      const { declaredValue, goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(declaredValue) > 0) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
        this.prevStandardCost = -1
      }
    },
    changeValue(data) {
      
      if (data && data.zipcode) {
        this.formData.transferPostalCode = data.zipcode
      }
      this.calcStandardCost(this.formData)
    },
    receiverchangeValue(data) {
      if (data && data.zipcode) {
        this.formData.receiverPostalCode = data.zipcode
      }
      this.calcStandardCost(this.formData)
      debugger
      if(data&&data.areaId){
        this.verifyCollectionfee(data)
      }else{
  
        this.showCollectionfee=false
        this.formData.isCollectionfee=0
        this.formData.collectionfee=0.00
        this.formData.collectionfeeTax=0.00
      }

    },
    senderchangeValue(data) {
      if (data && data.zipcode) {
        this.formData.senderPostalCode = data.zipcode
      }
      this.calcStandardCost(this.formData)
    },
    // 通过邮编改变省市区
    async changeAddress(zipCode, type) {
      if (zipCode.length !== 5 && zipCode.length !== 0) return
      const { code, msg, data } = await Api.GET_QUERY_AREA({ current: 1, size: 9999, zipcode: zipCode })
      if (code === RESPONSE_SUCCESS) {
        const records = data.filter(item => item.type === 4 || item.type === 5)
        if (records.length > 0) {
          if (type === 1) {
            this.$refs.senderProvinceSearch.selectSearchClick(records[0])
          } else if (type === 2) {
            this.$refs.receiverProvinceSearch.selectSearchClick(records[0])
          } else {
            this.$refs.transferProvinceSearch.selectSearchClick(records[0])
          }
        }
      } else {
        this.$message.warning(msg)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.group-title {
  border-bottom: 1px dashed #eeeeee;
  // margin-bottom: 20px;
  margin: 0 10px 20px 10px;
  padding: 16px 0px;
  .title {
    font-size: 14px;
    color: #333;
    font-weight: 600;
    display: inline-block;
    line-height: 7px;
    border-bottom: 4px solid #e0bd7b;
  }
  .insert-info {
    display: inline-block;
    margin-left: 60px;
    position: relative;
    .icon {
      color: #e0bd7b;
      position: absolute;
      overflow: visible;
    }
    .text {
      color: #666666;
      margin-left: 20px;
    }
  }
}
.el-form-item {
  padding: 0px 8px 18px 8px !important;
}
.group-content {
  background: #f7f7f9;
  padding: 20px 20px 10px;
  border-radius: 8px;
}

.w180 {
  // width: calc(20% + 160px);
  width: 400px !important;
  .el-input {
    width: 360px !important;
  }
}
.w360 .el-input {
  width: 360px !important;
}
</style>
<style lang="scss">
.el-dialog__wrapper .el-dialog.j-dialog {
  margin-bottom: 0 !important;
}
.el-dialog__wrapper .el-dialog.j-dialog .el-dialog__body {
  max-height: 700px;
  overflow: auto;
  padding: 10px 20px;
  .dialog-footer {
    border-top: 0;
    margin-top: 0px;
    margin-bottom: 20px;
  }
}
</style>
<style lang="scss">
.el-form.el-form-edit .el-form-item.insured-info .el-form-item__content {
  position: relative;
  .btn-insured {
    // color: #2D7CFF;
    color: #e60012;
    font-size: 12px;
    cursor: pointer;
    position: absolute;
    right: 24px;
    top: -22px;
    display: inline-block;
    height: 22px;
    line-height: 16px;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
